export default "__VITE_ASSET__DDNzFWIC__"